import { render, staticRenderFns } from "./ModalEndFeature.vue?vue&type=template&id=85723ac2"
import script from "./ModalEndFeature.vue?vue&type=script&lang=ts"
export * from "./ModalEndFeature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports